module.exports = __webpack_public_path__ + "coin_DKPC.png?46d3ddd7d9c4cbaecdd72e2aaea64c83";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_DKPC.png
// module id = 1124
// module chunks = 2